import { __decorate, __metadata } from "tslib";
import { Type } from 'class-transformer';
import { IClockWorkEntryDTO, ClockWorkEntryModel } from './clockWorkEntry';
let ClockWorkEntryOperation = /** @class */ (() => {
    var _a;
    class ClockWorkEntryOperation {
    }
    __decorate([
        Type(() => ClockWorkEntryModel),
        __metadata("design:type", typeof (_a = typeof IClockWorkEntryDTO !== "undefined" && IClockWorkEntryDTO) === "function" ? _a : Object)
    ], ClockWorkEntryOperation.prototype, "entryPayLoad", void 0);
    return ClockWorkEntryOperation;
})();
export { ClockWorkEntryOperation };
